import {
  DEFAULT_FEATURE_FLAGS,
  FEATURE_FLAG_NAME,
  FeatureFlagName,
  FeatureFlagNameMap,
  FeatureFlagsType,
} from '../featureFlags';

import { useKameleoonFeatureFlags } from './useKameleoonFeatureFlags';

export const useFeatureFlag = <T extends FeatureFlagName>(
  getName: (flagNames: FeatureFlagNameMap) => T,
): FeatureFlagsType[T] => {
  const flagName = getName(FEATURE_FLAG_NAME);
  const flagDefaultValue = DEFAULT_FEATURE_FLAGS[flagName];

  const { featureFlags } = useKameleoonFeatureFlags();

  const value = featureFlags?.[flagName] ?? flagDefaultValue;

  return value;
};
